<div class="header mat-elevation-z2">
  <interior-header (clickBotonSidenav)="alternarSideNav(sidenav)"></interior-header>
</div>

<mat-sidenav-container class="contenedor-principal">
  <mat-sidenav #sidenav mode="side" class="sidenav">
    <interior-sidenav></interior-sidenav>
  </mat-sidenav>

  <mat-sidenav-content class="contenido mat-app-background">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
